// src/widgets/utils/queryParams.ts
import { WidgetConfig } from '../types/config';

/**
 * Parses query parameters from the URL and merges them into the provided config
 */
export function parseQueryParams(config: WidgetConfig): WidgetConfig {
  if (!config.parseQueryParams) {
    return config;
  }

  const searchParams = new URLSearchParams(window.location.search);
  const updatedConfig = { ...config };

  // Parse boolean parameters
  [
    'hideHeader',
    'hideConversationList',
    'isFullPage',
    'hideBranding',
    'autoOpen',
  ].forEach((param) => {
    const value = searchParams.get(param);
    if (value !== null) {
      (updatedConfig as any)[param] = value === 'true';
    }
  });

  // Parse string parameters
  ['userPhone', 'apiHost', 'authToken', 'buttonText'].forEach((param) => {
    const value = searchParams.get(param);
    if (value !== null) {
      (updatedConfig as any)[param] = value;
    }
  });

  // Handle theme parameters
  const primaryColor = searchParams.get('primaryColor');
  const secondaryColor = searchParams.get('secondaryColor');
  const buttonBottomSpacing = searchParams.get('buttonBottomSpacing');
  const fontFamily = searchParams.get('fontFamily');

  if (primaryColor || secondaryColor || buttonBottomSpacing || fontFamily) {
    updatedConfig.theme = {
      ...(updatedConfig.theme || {}),
      ...(primaryColor && { primaryColor }),
      ...(secondaryColor && { secondaryColor }),
      ...(buttonBottomSpacing && { buttonBottomSpacing }),
      ...(fontFamily && { fontFamily }),
    };
  }

  // For position, only accept valid values
  const position = searchParams.get('position');
  if (position === 'left' || position === 'right') {
    updatedConfig.position = position;
  }

  return updatedConfig;
}
